module.exports = __webpack_public_path__ + "static/media/GerhardWagler.c62a965d.jpg";